import React, { useEffect } from "react";
export default function PaymentModal({ open, form, setForm, errors, onClose, onSubmit }) {
    useEffect(() => {
        if (!open) return;
        const onKeyDown = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [open, onClose]);
    if (!open) return null;

    function handleChange(e) {
        const {name,value}= e.target;

        setForm((p) => ({ ...p, [name]: value }));
    }
    return (
        <div
            role="dialog"
            aria-modal="true"
            onMouseDown={ (e) => e.target === e.currentTarget && onClose() }
            style={ {
                position: "fixed",
                inset: 0,
                background: "rgba(5, 5, 5, 0.47)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 16,
                zIndex: 2000,
            } }
        >
            <div
                className="card admin-card"
                style={ {
                    width: "min(980px, 100%)",
                    maxHeight: "90vh",
                    overflow: "auto",
                } }
            >
                <div className="card-body p-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <h5 className="mb-0 text-light">
                            
                           Setup Cost for Various Countries - {form.title}
                        </h5>
                        <button className="btn btn-sm btn-outline-light" onClick={ onClose }>
                            ✕
                        </button>
                    </div>

                    <form
                        onSubmit={ (e) => {
                            e.preventDefault();
                            onSubmit();
                        } }
                    >
                        <div className="row g-3">
                            <div className="col-12 col-md-6">
                                <label className="form-label text-white-50">Country</label>
                                <select
                                    className={ `form-control bg-dark text-light border-secondary`}
                                    name="country"
                                    onChange={ handleChange }
                                >
                                    <option value="">Select Country</option>
                                    <option value="UK">UK</option>
                                    <option value="GHANA">GHANA</option>
                                </select>

                            </div>
                            <div className="col-12 col-md-6">
                                <label className="form-label text-white-50">Amount</label>
                                <input
                                    className={ `form-control bg-dark text-light border-secondary` }
                                    type="number"
                                    name="amount"
                                    onChange={ handleChange }
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <button
                                type="button"
                                className="btn btn-outline-light"
                                onClick={ onClose }
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary">
                                Save Cost
                            </button>
                            
                        </div>
                    </form>
                </div>
            </div>
            
        </div>
    );
}